import type { Country } from '@kitopi-com/customer-auth';
import { useQuery } from '@tanstack/react-query';
import { fetchCountriesFromFirebase } from 'api/api';
import { FIREBASE_COUNTRIES_FALLBACK } from 'utils/constants';

export const useFirebaseCountries = (): Country[] => {
  const { data } = useQuery({
    queryKey: ['firebase-countries'],
    queryFn: fetchCountriesFromFirebase,
    retry: 1,
    staleTime: 5 * 60 * 1000,
  });

  return data ?? FIREBASE_COUNTRIES_FALLBACK;
};
